import React, { PropTypes } from 'react';
import { MESSAGE_TYPE } from 'reducers/chat/message';
import configuration from 'config';
import ChatInteractiveSurveyAsk from 'containers/chat/interactiveSurvey/Ask';
import ChatInteractiveSurveyAdditionalData from 'containers/chat/interactiveSurvey/AdditionalData';
import ImageMessage from 'containers/chat/fileUpload/ImageMessage';
import FileMessage from 'containers/chat/fileUpload/FileMessage';
import { messagePropTypes } from './propTypes';
import './fileUpload/fileUploadMessages.scss';

const createMarkup = text => ({ __html: text });

const chatMessage = ({ message, className }) => {
  switch (message.type) {
    case MESSAGE_TYPE.interactiveSurvey.ask:
      return <ChatInteractiveSurveyAsk className={className} message={message}>{message.content}</ChatInteractiveSurveyAsk>;
    case MESSAGE_TYPE.interactiveSurvey.additionalData:
      return <ChatInteractiveSurveyAdditionalData className={className} message={message} />;
    case MESSAGE_TYPE.image:
      return <ImageMessage className={className} 
        imageId={message.content.id} 
        imageUrl={message.content.url} 
        imageComments={message.content.comments}
        imageGuid={message.content.guid}
      />;
    case MESSAGE_TYPE.file:
      return <FileMessage className={className} guid={message.content.guid} fileName={message.content.fileName} />;
    default:
      return <p className={className} dangerouslySetInnerHTML={createMarkup(message.content)}></p>;
  }
};

chatMessage.propTypes = {
  className: PropTypes.string.isRequired,
  message: messagePropTypes,
  additionalProps: PropTypes.object,
};

export default chatMessage;



// WEBPACK FOOTER //
// ./components/chat/ChatMessage.js